import { createAction } from 'redux-actions';

export const logout = createAction('LOGOUT');
export const logoutSuccess = createAction('LOGOUT_SUCCESS');
export const logoutFail = createAction('LOGOUT_FAIL');

export const setLoading = createAction('SET_LOADING', (loading, message) => ({ loading, message }));
export const navigate = createAction('NAVIGATE', route => ({ route }));
export const setAppLoaded = createAction('SET_APP_LOADED', loaded => ({ loaded }));

export const loginFromToken = createAction('LOGIN_FROM_TOKEN', jwt => ({ jwt }));
export const loginFromTokenSuccess = createAction('LOGIN_FROM_TOKEN_SUCCESS', (user, token) => ({ user, token }));
export const loginFromTokenFail = createAction('LOGIN_FROM_TOKEN_FAIL', error => ({ error }));

export const setRoles = createAction('SET_ROLES', roles => ({ roles }));
export const setRolesSuccess = createAction('SET_ROLES_SUCCESS');
export const setRolesFail = createAction('SET_ROLES_FAIL');

export const login = createAction('LOGIN', credentials => ({ credentials }));
export const loginSuccess = createAction('LOGIN_SUCCESS', (user, token) => ({ user, token }));
export const loginFail = createAction('LOGIN_FAIL', error => ({ error }));

export const loginOauth = createAction('LOGIN_OAUTH', accessToken => ({ accessToken }));
export const loginOauthSuccess = createAction('LOGIN_OAUTHSUCCESS', (user, token) => ({ user, token }));
export const loginOauthFail = createAction('LOGIN_OAUTHFAIL', error => ({ error }));

export const updatePassword = createAction('UPDATE_PASSWORD', credentials => ({ credentials }));
export const updatePasswordSuccess = createAction('UPDATE_PASSWORD_SUCCESS');
export const updatePasswordFail = createAction('UPDATE_PASSWORD_FAIL');

export const resetPassword = createAction('RESET_PASSWORD', email => ({ email }));
export const resetPasswordSuccess = createAction('RESET_PASSWORD_SUCCESS');
export const resetPasswordFail = createAction('RESET_PASSWORD_FAIL', message => ({ message }));

export const redirectFromLogin = createAction('REDIRECT_FROM_LOGIN');
export const hydrate = createAction('HYDRATE');
